import { useQuery } from 'react-query'

import {
  getMyTranscriptsApi,
  getUserTranscriptsApi
} from './api'

const KEYS = {
  MINE: 'integrations/transcripts/me',
  USER: 'integrations/transcripts/user'
}

export const useTranscripts = (
  provider,
  { limit = 20, enabled = true } = {}
) => {
  const queryKey = [KEYS.MINE, provider, limit]
  const { data, isLoading, error, refetch } = useQuery(
    queryKey,
    () => getMyTranscriptsApi({ provider, limit }),
    { enabled: enabled && Boolean(provider) }
  )

  return {
    transcripts: data || [],
    isLoading,
    error,
    refetch
  }
}

export const useUserTranscripts = (
  userId,
  provider,
  { limit = 20, enabled = true } = {}
) => {
  const queryKey = [KEYS.USER, userId, provider, limit]
  const { data, isLoading, error, refetch } = useQuery(
    queryKey,
    () => getUserTranscriptsApi({ userId, provider, limit }),
    { enabled: enabled && Boolean(userId) && Boolean(provider) }
  )

  return {
    transcripts: data || [],
    isLoading,
    error,
    refetch
  }
}
